import { dbiBtnLogMes } from '@/pages/intelligence/utils/buriedPointCfg';
import { btnPointInter } from '@home/utils/buriedPoint';
import { dbhBtnLogMes } from '@home/utils/buriedPointCfg';

export type ReportPageType = {
    // 报告类型
    reportType: string;
    // 用于接口有用 /api/v1/util/resource/${systemIdCur}/:resource_id/:language
    systemIdCur: string;
    // 下载打点id, 需要在打点里面添加对应的信息
    downloadLogKeyCur: btnPointInter | string;
    // 打开报告打点
    BtnLogMesCur: btnPointInter;
    // 点赞打点
    logMsgCur?: btnPointInter;
    // 分享打点
    btnLogCfgCur: btnPointInter;
    // 分享文本
    shareTypeCur: string;
    // 搜索类型
    searchTypeCur: string;
    // 页面的路径，没什么用了；以前的代码Model弹窗没了
    pagePathCur?: string;
    // 是否有点赞展示
    showLiked: boolean;
    // 是否有浏览展示
    showView: boolean;
    // 是否点赞可点击
    likedClickable?: boolean;
    // 是否统计浏览量
    countView?: boolean;
};

export const pageReportTypeConfig: { [key: string]: ReportPageType } = {
    gameResearchReport: {
        reportType: 'gameResearchReport',
        systemIdCur: 'gameResearch',
        downloadLogKeyCur: 'gameResearchDownload',
        // downloadLogKeyCur: dbiBtnLogMes.gameResearchDownload,
        BtnLogMesCur: dbiBtnLogMes.gameResearchReportsDetail,
        logMsgCur: dbiBtnLogMes.gameResearchLike,
        btnLogCfgCur: dbiBtnLogMes.gameResearchShare,
        shareTypeCur: 'dbi_report_share_success_game_research',
        searchTypeCur: 'gameResearchSearch',
        pagePathCur: '/intelligence/gameResearchReport',
        showLiked: true,
        showView: false,
        countView: true,
        likedClickable: true,
    },
    aiHubReports: {
        reportType: 'aiHubReports',
        systemIdCur: 'intelligence_ai',
        downloadLogKeyCur: 'aiHubReportsDownload',
        BtnLogMesCur: dbiBtnLogMes.aiHubReportsDetail,
        logMsgCur: dbiBtnLogMes.aiHubReportsLike,
        btnLogCfgCur: dbiBtnLogMes.aiHubReportsShare,
        shareTypeCur: 'dbi_report_share_success_ai_hub',
        searchTypeCur: 'aiHubReportsSearch',
        pagePathCur: '/intelligence/reports/aiHubReports',
        showLiked: true,
        showView: false,
        countView: true,
        likedClickable: true,
    },
    insightsReports: {
        reportType: 'insightsReports',
        systemIdCur: 'intelligence_insights',
        downloadLogKeyCur: 'insightsReportsDownload',
        // downloadLogKeyCur: dbiBtnLogMes.insightsReportsDownload,
        BtnLogMesCur: dbiBtnLogMes.insightsReportsDetail,
        logMsgCur: dbiBtnLogMes.insightsReportsLike,
        btnLogCfgCur: dbiBtnLogMes.insightsReportsShare,
        shareTypeCur: 'dbi_report_share_success_insight',
        searchTypeCur: 'insightsReportSearch',
        pagePathCur: '/intelligence/reports/insightsReports',
        showLiked: true,
        showView: false,
        countView: true,
        likedClickable: true,
    },
    insightsCenterLibrary: {
        reportType: 'insightsCenterLibrary',
        systemIdCur: 'intelligence_iic',
        downloadLogKeyCur: 'insightsCenterLibraryDownload',
        // downloadLogKeyCur: dbiBtnLogMes.insightsCenterLibraryDownload,
        BtnLogMesCur: dbiBtnLogMes.insightsCenterLibraryDetail,
        logMsgCur: dbiBtnLogMes.insightsCenterLibraryLike,
        btnLogCfgCur: dbiBtnLogMes.insightsCenterLibraryShare,
        shareTypeCur: 'dbi_report_share_success_insight_center_library',
        searchTypeCur: 'insightsCenterLibrarySearch',
        pagePathCur: '/intelligence/reports/insightsCenterLibrary',
        showLiked: true,
        countView: true,
        showView: false,
        likedClickable: true,
    },
    gameAnalysis: {
        reportType: 'gameAnalysis',
        systemIdCur: 'game_analysis',
        downloadLogKeyCur: 'gameAnalysisDownload',
        // downloadLogKeyCur: dbiBtnLogMes.gameAnalysisDownload,
        BtnLogMesCur: dbiBtnLogMes.gameAnalysisReportsDetail,
        logMsgCur: dbiBtnLogMes.gameAnalysisLike,
        btnLogCfgCur: dbiBtnLogMes.gameAnalysisShare,
        shareTypeCur: 'dbi_report_share_success_game_analysis',
        searchTypeCur: 'GameAnalysisSearch',
        pagePathCur: '/intelligence/reports/GameAnalysis',
        showLiked: true,
        showView: false,
        likedClickable: true,
    },
    studioReport: {
        reportType: 'studioReport',
        systemIdCur: 'studio_report',
        // 下载打点id, 需要在打点里面添加对应的信息
        downloadLogKeyCur: dbhBtnLogMes.studioReportisDownload,
        // 打开报告打点
        BtnLogMesCur: dbhBtnLogMes.studioReportisDetail,
        // 分享打点
        btnLogCfgCur: dbhBtnLogMes.studioReportisShare,
        // 分享文本
        shareTypeCur: 'dbi_report_share_success_insight',
        searchTypeCur: 'studioReportSearch',
        // pagePathCur: '',
        showLiked: false,
        showView: true,
    },
};

// Market Reports 对应的 SystemID
export const MARKET_REPORTS_SYSTEM_ID = 'intelligence';

// 调整展示样式的报告类型
export const NEW_PDF_PREVIEW_STYLE_REPORTS = [
    MARKET_REPORTS_SYSTEM_ID,
    pageReportTypeConfig.insightsReports.systemIdCur,
    pageReportTypeConfig.aiHubReports.systemIdCur,
    pageReportTypeConfig.insightsCenterLibrary.systemIdCur,
    pageReportTypeConfig.gameResearchReport.systemIdCur,
];

// 根据报告类型ID获取对应报告类型配置
export function findReportObjectBySystemId(cfg: { [key: string]: ReportPageType }, name: string) {
    // eslint-disable-next-line no-restricted-syntax
    for (const key in cfg) {
        if (cfg?.[key].systemIdCur === name) {
            return cfg?.[key];
        }
    }
    return null;
}

export const formatReportLike = (number?: number) => {
    if (!number && number !== 0) return;
    if (number > 10000) {
        return `${Number.parseInt(String(number / 1000), 10)}k`;
    }
    return String(number);
};

/**
 * 根据 system 字段获取对应的报告类型配置
 */
export const getReportTypeConfig = (system: string): ReportPageType => {
  const configMap: Record<string, ReportPageType> = {
    intelligence_insights: pageReportTypeConfig.insightsReports,
    intelligence_iic: pageReportTypeConfig.insightsCenterLibrary,
    gameResearch: pageReportTypeConfig.gameResearchReport,
    intelligence_ai: pageReportTypeConfig.aiHubReports,
    intelligence: {
      ...pageReportTypeConfig.insightsReports,
      systemIdCur: 'intelligence',
      downloadLogKeyCur: 'MarketReportsDownload',
    },
  };

  return configMap[system] || {
    ...pageReportTypeConfig.studioReport,
    showLiked: true,
    showView: false,
    likedClickable: true,
  };
};
